var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"d-flex justify-space-between align-center"},[_c('div',[_vm._v("@"+_vm._s(_vm.year)+" - "+_vm._s(_vm.company))]),_c('div',[_vm._v("Suporte técnico")])])}
var staticRenderFns = []

export { render, staticRenderFns }